import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import FloatingSocial from '../components/common/FloatingSocial';

const MainLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <div className="d-flex flex-column min-vh-100 bg-site">
      <Header />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingSocial />
    </div>
  );
};

export default MainLayout;
